module.exports = __webpack_public_path__ + "img/collection-weddingRingsRosegold@2x.4daf67b.webp";